import { useState } from 'react';

export interface AnnouncementFormData {
  id?: string;
  title: string;
  description: any;
  propertyId: string | null;
  attachments: any[];
  deletedFiles: any[];

  IsBuilding?: boolean;
  IsLevel?: boolean;
  AnnouncementBuildingLevels?: any[];
  AnnouncementSuites?: any[];
}

export interface UseAnnouncementFormEntityStateReturn {
  announcementFormData: AnnouncementFormData;
  updateAnnouncementFormData: (partial: Partial<AnnouncementFormData>) => void;
  resetAnnouncementFormData: (next?: Partial<AnnouncementFormData>) => void;
}

const buildInitialState = (
  initial?: Partial<AnnouncementFormData>
): AnnouncementFormData => ({
  title: '',
  description: '',
  propertyId: null,
  attachments: [],
  deletedFiles: [],

  ...initial,
});

export const useAnnouncementFormEntityState = (
  initial?: Partial<AnnouncementFormData>
): UseAnnouncementFormEntityStateReturn => {
  const [announcementFormData, setAnnouncementFormData] =
    useState<AnnouncementFormData>(() => buildInitialState(initial));

  const updateAnnouncementFormData = (
    partial: Partial<AnnouncementFormData>
  ) => {
    setAnnouncementFormData((prev: AnnouncementFormData) => ({
      ...prev,
      ...partial,
    }));
  };

  const resetAnnouncementFormData = (next?: Partial<AnnouncementFormData>) => {
    setAnnouncementFormData(buildInitialState(next));
  };

  return {
    announcementFormData,
    updateAnnouncementFormData,
    resetAnnouncementFormData,
  };
};
